import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import customerProviderService from "../../services/customerProviderService";

import ProviderBanner from "../../components/customer/providerDetails/ProviderBanner";
import ProviderInfoCard from "../../components/customer/providerDetails/ProviderInfoCard";
import ProviderStats from "../../components/customer/providerDetails/ProviderStats";
import ProviderSearchBar from "../../components/customer/providerDetails/ProviderSearchBar";
import ProviderCategoryTabs from "../../components/customer/providerDetails/ProviderCategoryTabs";
import ProviderFoodGrid from "../../components/customer/providerDetails/ProviderFoodGrid";
import ProviderReviewSection from "../../components/customer/providerDetails/ProviderReviewSection";
import ProviderBusinessInfo from "../../components/customer/providerDetails/ProviderBusinessInfo";
import StickyCartBar from "../../components/customer/providerDetails/StickyCartBar";

import "./ProviderDetails.css";

export default function ProviderDetails() {
  const { providerId } = useParams();

  const [loading, setLoading] = useState(true);
  

  const [providerData, setProviderData] = useState(null);

  const [search, setSearch] = useState("");

  const [selectedCategory, setSelectedCategory] =
    useState("All");

  // Temporary cart state
  // Later we'll connect it to the real cart
 

  useEffect(() => {
    fetchProvider();
  }, [providerId]);

  const fetchProvider = async () => {
    try {
      setLoading(true);

      const res = await customerProviderService.getProvider(providerId);

setProviderData(res.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="provider-loading">
        Loading Provider...
      </div>
    );
  }

  if (!providerData) {
    return (
      <div className="provider-error">
        Provider Not Found
      </div>
    );
  }

  const {
    provider,
    foods,
    foodCategories,
    reviews,
    stats,
  } = providerData;
  console.log("Provider:", provider);
console.log("Foods:", foods);
console.log("First Food:", foods[0]);
console.log("Food Categories:", foodCategories);
console.log("Reviews:", reviews);
console.log("Stats:", stats);
console.log("Provider Photos:", provider.photos);


  
  return (
    <div className="provider-details-page">

      <ProviderBanner
        provider={provider}
      />

      <ProviderInfoCard
        provider={provider}
      />

      <ProviderStats
        stats={stats}
      />

      <ProviderSearchBar
        search={search}
        setSearch={setSearch}
      />

      <ProviderCategoryTabs
        categories={foodCategories}
        selectedCategory={selectedCategory}
        setSelectedCategory={
          setSelectedCategory
        }
      />

      <ProviderFoodGrid
        foods={foods}
        search={search}
        selectedCategory={selectedCategory}
      />

      <ProviderReviewSection
        reviews={reviews}
        stats={stats}
      />

      <ProviderBusinessInfo
        provider={provider}
      />

       <StickyCartBar
  providerId={
    provider?._id ||
    provider?.id ||
    providerId
  }
/>

    </div>
  );
}